module.exports = __webpack_public_path__ + "7f210cab915260571b464377f33c7dac.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/settings/restaurantSetting2.png
// module id = 705
// module chunks = 0